module.exports = __webpack_public_path__ + "img/perkawinan.fb1ac79c.jpg";